import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

import SimpleDivider from '../../../../../Components/Dividers/SimpleDivider';
import PhoneWithCountryCodeInput from '../../../../../Components/Inputs/PhoneWithCountryCodeInput';
import SweetAlert from '../../../../../Components/Alerts/SweetAlert';

const ContractAssociationFormPhone = ({
  currentUser,
  loading,
  onValuesChange,
  classes,
  phoneInputValues = {}
}) => {
  const innerClasses = useStyles();

  return (
    <>
      <SimpleDivider withoutMargin className={classes.itemDivider} />

      <Grid container alignItems="center">
        <Grid container item xs={12} sm={6} md={7} alignItems="center">
          <Typography className={innerClasses.itemText}>
            Agrega y valida un número de teléfono para mantenerte informado
            sobre el estado de tu contrato.
          </Typography>
        </Grid>
        <Grid container item xs={12} sm={6} md={5} alignItems="center">
          <PhoneWithCountryCodeInput
            countryCode={currentUser && currentUser.phoneCountryCode}
            phoneNumber={currentUser && currentUser.phone}
            loading={loading}
            onValuesChange={onValuesChange}
            classes={{
              root: classes.phoneInputContainer,
              countryCodeInput: classes.countryCodeInput,
              phoneInput: classes.phoneInput
            }}
          />
        </Grid>
        {phoneInputValues.isValid && phoneInputValues.phone && (
          <Grid item xs={12} className={innerClasses.alertMessage}>
            <SweetAlert message="Se te solicitará verificar tu número de celular antes de asociar." />
          </Grid>
        )}
      </Grid>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  itemText: {
    fontSize: 14,
    fontWeight: 500,
    paddingBottom: theme.spacing(),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      paddingBottom: theme.spacing(2),
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  alertMessage: {
    marginBottom: theme.spacing(2)
  }
}));

export default ContractAssociationFormPhone;
